const Terms = () => {
  const sections = [
    {
      title: "1. Allgemeines",
      subsections: [
        {
          content: "1.1 Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die Vertragsbeziehung zwischen der Angel & Devil Agency LLC (nachfolgend \"Angel & Devil Network\" genannt) und den Nutzern ihrer Dienstleistungen (nachfolgend \"Performer\" oder \"Kunden\")."
        },
        {
          content: "1.2 Mit der Nutzung unserer Dienstleistungen erklärt sich der Performer mit diesen AGB einverstanden."
        }
      ]
    },
    {
      title: "2. Leistungen von Angel & Devil Network",
      subsections: [
        {
          content: "2.1 Angel & Devil Network bietet Dienstleistungen für Performer in der Webcam-Branche an, darunter:",
          list: [
            "Bereitstellung von technischem Equipment.",
            "Zugang zu Studio-Wohnungen.",
            "Beratung und Unterstützung zur Content-Produktion.",
            "Netzwerkzugang zu Plattformen."
          ]
        },
        {
          content: "2.2 Die Dienstleistungen können individuell oder als Komplettpaket in Anspruch genommen werden."
        }
      ]
    },
    {
      title: "3. Registrierung und Vertragsschluss",
      subsections: [
        {
          content: "3.1 Die Nutzung unserer Dienstleistungen setzt eine erfolgreiche Registrierung voraus. Performer müssen wahrheitsgemäße Angaben machen."
        },
        {
          content: "3.2 Mit der Registrierung und Annahme durch Angel & Devil Network kommt der Vertrag zustande."
        }
      ]
    },
    {
      title: "4. Pflichten des Performers",
      subsections: [
        {
          content: "4.1 Der Performer verpflichtet sich, die bereitgestellten Ressourcen ausschließlich für legale und im Rahmen der vereinbarten Zwecke erlaubte Tätigkeiten zu nutzen."
        },
        {
          content: "4.2 Der Performer trägt die Verantwortung für die Einhaltung geltender gesetzlicher Vorschriften, einschließlich steuerlicher und gewerblicher Verpflichtungen."
        },
        {
          content: "4.3 Schäden an bereitgestelltem Equipment müssen umgehend gemeldet werden."
        }
      ]
    },
    {
      title: "5. Haftung und Gewährleistung",
      subsections: [
        {
          content: "5.1 Angel & Devil Network haftet nicht für entgangene Einnahmen oder sonstige finanzielle Schäden, die durch die Nutzung oder Nichtnutzung der bereitgestellten Dienstleistungen entstehen."
        },
        {
          content: "5.2 Für Schäden an Equipment, die durch unsachgemäßen Gebrauch entstehen, haftet der Performer."
        }
      ]
    },
    {
      title: "6. Nutzung des Wohnnetzwerks",
      subsections: [
        {
          content: "6.1 Studio-Wohnungen stehen Performer zur Verfügung, die mindestens sechs Monate mit Angel & Devil Network zusammenarbeiten."
        },
        {
          content: "6.2 Die Nutzung der Wohnungen erfolgt ausschließlich für die vereinbarten Zwecke (z. B. Content-Produktion, Streaming)."
        },
        {
          content: "6.3 Bei Verstößen gegen die Nutzungsbedingungen behält sich Angel & Devil Network das Recht vor, den Zugang zum Wohnnetzwerk zu verweigern."
        }
      ]
    },
    {
      title: "7. Datenschutz",
      content: "Die Verarbeitung personenbezogener Daten erfolgt gemäß unserer Datenschutzerklärung. Performer erklären sich mit der Speicherung und Verarbeitung ihrer Daten im Rahmen der Zusammenarbeit einverstanden."
    },
    {
      title: "8. Kündigung des Vertrags",
      subsections: [
        {
          content: "8.1 Der Vertrag kann von beiden Parteien jederzeit mit einer Frist von 30 Tagen schriftlich gekündigt werden."
        },
        {
          content: "8.2 Angel & Devil Network behält sich das Recht vor, den Vertrag fristlos zu kündigen, wenn der Performer gegen wesentliche Vertragsbedingungen verstößt."
        }
      ]
    },
    {
      title: "9. Schlussbestimmungen",
      subsections: [
        {
          content: "9.1 Änderungen oder Ergänzungen dieser AGB bedürfen der Schriftform."
        },
        {
          content: "9.2 Sollte eine Bestimmung dieser AGB unwirksam sein, bleiben die übrigen Bestimmungen davon unberührt."
        },
        {
          content: "9.3 Es gilt das Recht des US-Bundesstaates Florida."
        }
      ]
    }
  ];

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 overflow-hidden w-full">
        <div className="absolute inset-0 bg-gradient-to-b from-deep-black via-deep-black/95 to-deep-black -z-10"></div>
        <div className="absolute -top-1/2 right-0 w-3/4 h-full bg-gradient-to-bl from-hot-pink/20 to-accent-purple/20 blur-3xl animate-float"></div>
        <div className="absolute -bottom-1/2 left-0 w-3/4 h-full bg-gradient-to-tr from-neon-blue/20 to-hot-pink/20 blur-3xl animate-float" style={{ animationDelay: '-3s' }}></div>

        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-6">
              AGB – <span className="text-gradient">Angel & Devil Network</span>
            </h1>
            <div className="space-y-2 text-white/80">
              <p>Angel & Devil Agency LLC</p>
              <p>7901 4th St N, St. Petersburg, FL 33702, USA</p>
              <p>
                📧 E-Mail:{" "}
                <a
                  href="mailto:info@angel-devil.network"
                  className="text-hot-pink hover:text-accent-purple transition-colors"
                >
                  info@angel-devil.network
                </a>
              </p>
              <p>
                📞 Telefon:{" "}
                <a
                  href="tel:+13057776989"
                  className="text-hot-pink hover:text-accent-purple transition-colors"
                >
                  +1 305 777 6989
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content Sections */}
      <section>
        <div className="w-full">
          <div className="space-y-20">
            {sections.map((section, index) => (
              <div key={index} className={`flex ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}>
                <div className="relative w-full">
                  <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
                  <div className="relative glass-effect rounded-2xl p-8">
                    <div className="flex items-start gap-6">
                      <div className="shrink-0">
                        <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-hot-pink to-accent-purple flex items-center justify-center">
                          <span className="text-white text-xl">{index + 1}</span>
                        </div>
                      </div>
                      <div>
                        <h2 className="text-2xl font-playfair text-gradient mb-4">
                          {section.title}
                        </h2>
                        {section.subsections ? (
                          <div className="space-y-4">
                            {section.subsections.map((subsection, subIndex) => (
                              <div key={subIndex} className="text-white/80">
                                <p>{subsection.content}</p>
                                {subsection.list && (
                                  <ul className="list-disc pl-6 mt-2 space-y-1">
                                    {subsection.list.map((item, itemIndex) => (
                                      <li key={itemIndex}>{item}</li>
                                    ))}
                                  </ul>
                                )}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="text-white/80">{section.content}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact Section */}
        <div className="w-full mt-20 text-center">
          <p className="text-white/80">
            Angel & Devil Network – Where{" "}
            <span className="text-hot-pink">Temptation</span> Meets{" "}
            <span className="text-accent-purple">Talent</span>.
          </p>
          <p className="text-white/80 mt-4">
            Fragen zu unseren AGB? Kontaktiere uns unter{" "}
            <a
              href="mailto:info@angel-devil.network"
              className="text-hot-pink hover:text-accent-purple transition-colors"
            >
              info@angel-devil.network
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Terms;
